import {ReactElement} from 'react'

import {PersonIcon} from 'components'
import {DopaminePromptSuggestion} from './DopamineAssistant.types'

type DopamineAssistantSuggestionIconProps = Pick<
  DopaminePromptSuggestion,
  'icon'
>

export const DopamineAssistantSuggestionIcon = ({
  icon,
}: DopamineAssistantSuggestionIconProps): ReactElement => {
  if (icon === 'shield') {
    return (
      <svg
        aria-hidden="true"
        className="h-4 w-4"
        fill="none"
        focusable="false"
        viewBox="0 0 24 24"
      >
        <path
          d="M12 3l7 3v5.5c0 4.4-3 7.4-7 8.5-4-1.1-7-4.1-7-8.5V6l7-3z"
          stroke="currentColor"
          strokeLinejoin="round"
          strokeWidth="1.6"
        />
        <path
          d="M9 12l2 2 4-4"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.6"
        />
      </svg>
    )
  }

  if (icon === 'users') {
    return <PersonIcon classes="h-4 w-4" strokeColor="currentColor" />
  }

  return (
    <svg
      aria-hidden="true"
      className="h-4 w-4"
      fill="none"
      focusable="false"
      viewBox="0 0 24 24"
    >
      <rect
        height="7.5"
        rx="1.6"
        stroke="currentColor"
        strokeWidth="1.6"
        width="7.5"
        x="3"
        y="3"
      />
      <rect
        height="7.5"
        rx="1.6"
        stroke="currentColor"
        strokeWidth="1.6"
        width="7.5"
        x="13.5"
        y="3"
      />
      <rect
        height="7.5"
        rx="1.6"
        stroke="currentColor"
        strokeWidth="1.6"
        width="7.5"
        x="3"
        y="13.5"
      />
      <rect
        height="7.5"
        rx="1.6"
        stroke="currentColor"
        strokeWidth="1.6"
        width="7.5"
        x="13.5"
        y="13.5"
      />
    </svg>
  )
}
